import styled from "styled-components";

export const Container = styled.div`
  width: 100%;
  height: 90vh;
  margin: 20px 0 0 0;
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: flex-start;
`;
